import { useRef } from 'react'
import { gsap, prefersReduced } from '../../lib/gsap.js'
import useIso from './useIso.js'

// Fade the incoming view in when viewKey changes. Skips the first mount (the
// entrance stagger owns that moment). Reduced-motion => instant.
export default function useViewFade(ref, viewKey) {
  const first = useRef(true)
  useIso(() => {
    if (first.current) { first.current = false; return }
    const el = ref.current
    if (!el || prefersReduced()) return
    gsap.fromTo(el, { opacity: 0 }, { opacity: 1, duration: 0.18, ease: 'power1.out' })
  }, [viewKey])
}
